// extracted by mini-css-extract-plugin
module.exports =  {"proof":"_93444fe79c--proof--FOsx6","icon":"_93444fe79c--icon--tB2fK"};